import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-banner',
  templateUrl: './app-banner.component.html',
  styleUrls: ['./app-banner.component.scss']
})
export class AppBannerComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    mainBannerContent: Content[] = [
        {
            title: 'Move money across Africa in secs.',
            paragraph: 'Sending money across Africa should be easier than sending email. Feel the power of hassle-free payments, anytime, anywhere.',
            button1: 'assets/img/store/1.png',
            button2: 'assets/img/store/2.png'
        }
    ]
    bannerImage: Image[] = [
        {
            img: 'assets/img/app-banner.png'
        }
    ]

}
class Content {
    title : string;
    paragraph : string;
    button1 : string;
    button2 : string;
}
class Image {
    img : string;
}